import {useQuery} from "@tanstack/react-query";
import {readAllRevenueByCompany, readRevenueByCompany} from "../../../../../api/main/SalesApi";
import {SalesSearchParamType} from "../interface";
import {salesRevenueByCompanyAllMapInit} from "../state";

interface Props {
    param: SalesSearchParamType
    enabled: boolean
}

export const useReadAllRevenueByCompany = ({param, enabled}: Props) => {
    const {data} = useQuery({
        queryKey: ["readRevenueByCompany", param],
        queryFn: async () => await readAllRevenueByCompany(param),
        select: (res) => res?.data.result ?? salesRevenueByCompanyAllMapInit,
        enabled: enabled
    });

    return {data};
};
